import { SelectOptionType } from '@config/type'
import { ToggleNavbarButton } from '@shared/layouts/navbar'
import cn from 'classnames'
import { AddressModel, AddressSelectList } from '@entities/address'
import { useSearchAddress } from '@features/address/model/hooks/use-search-address'
import '@features/address/model/store/address.epics'
import { LegacyRef, memo, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { GroupBase, MenuListProps } from 'react-select'

import { LogoLoupe } from '@components/logo/logo-loop'
import { Select } from '@components/select/core/select'

import styles from './search-address.module.css'

type SearchAddressProps = {
  className?: string
}

export const SearchAddress = memo(
  ({ className }: SearchAddressProps): JSX.Element => {
    const { t } = useTranslation('main')
    const selectRef = useRef<LegacyRef<any> | undefined>(null)

    const {
      isMenuOpened,
      address,
      autocompleteItems,
      handleAddressPartChange,
      handleAddressSelect,
      handleBlur,
      handleFocus,
      status
    } = useSearchAddress(selectRef)

    return (
      <div
        className={cn(styles.container, className, {
          [styles.opened]: isMenuOpened === true
        })}
      >
        <ToggleNavbarButton className={styles.burger} />
        <Select
          inputValue={address}
          value={address}
          searchable={true}
          placeholder={t('search-in-target-map')}
          options={autocompleteItems}
          // @ts-ignore
          getOptionLabel={(e: AddressModel) => e.getAddress()}
          onInputChange={handleAddressPartChange}
          menuIsOpen={isMenuOpened}
          withLeftPadding
          withRightPadding
          // @ts-ignore
          ref={selectRef}
          fullHeight
          sizeType="lg"
          fontType="md"
          styleType="secondary"
          onFocus={handleFocus}
          onBlur={handleBlur}
          isLoading={status === 'loading' || status === 'fetching'}
          // @ts-ignore
          onChange={handleAddressSelect}
          components={{
            // @ts-ignore
            MenuList: (
              props: MenuListProps<
                SelectOptionType<string>,
                false,
                GroupBase<SelectOptionType<string>>
              >
            ) => (
              // @ts-ignore
              <AddressSelectList
                {...props}
                sizeType={'md'}
                fontType={'md'}
                styleType={'secondary'}
              />
            )
          }}
          menuShouldBlockScroll={false}
        />
        <LogoLoupe className={styles.img} />
      </div>
    )
  }
)
